import { MutationStatus } from '@tanstack/react-query'
import { ReimbursementDetails } from '../create_reimbursement_form'
import ReviewDetails from './_components/review_details'
import { useStudentPurses } from '@/app/pages/providers/api/usePaymentProviders'
import { useSelector } from 'react-redux'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import PageLoader from '@/app/common/components/PageLoader/PageLoader'

type Props = {
  paymentDetails: ReimbursementDetails
  onSubmit: () => void
  mutationStatus: MutationStatus
}

export default function ReimbursementReviewPage(props: Props) {
  const { paymentDetails, onSubmit, mutationStatus } = props
  const application = useSelector(selectFamilyApplication)
  const programId = useSelector(selectProgramID)
  const purses = useStudentPurses({
    application_id: application.application_id,
    program_id: programId,
  })


  return (
    <PageLoader query={purses}>
      {(data) => {
        return (
          <ReviewDetails apiPurses={data} mutationStatus={mutationStatus} onSubmit={onSubmit} paymentDetails={paymentDetails} />
        )
      }}
    </PageLoader>
  )
}
